import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { PerfectScrollbarComponent, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CarregandoService } from '../../services/carregando.service';
import { ClienteService } from '../../services/cliente.service';
import { NotificacaoService } from '../../services/notificacao.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { IntegradorApontamentoService } from '../../services/integrador-apontamento.service';
import { IntegradorApontamento } from '../../models/integrador-apontamento';
import { SegmentacaoService } from '../../services/segmentacao.service';
import { PremissasService } from '../../services/premissas.service';
import { Cliente } from "../../models/cliente";

@Component({
  selector: "app-dados-do-integrador-carteira-integradores-modal",
  templateUrl: "./dados-do-integrador-carteira-integradores-modal.component.html",
  styleUrls: ["./dados-do-integrador-carteira-integradores-modal.component.scss"],
})
export class DadosDoIntegradorCarteiraIntegradoresModalComponent implements OnInit {
  idCliente;
  cliente: Cliente;
  apontamentos;
  apontamento;
  fidelidadeGoSolar;

  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild("perfectScrollDados", { static: false }) perfectScroll: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarComponent, { static: false }) componentRef?: PerfectScrollbarComponent;

  constructor(
    private dialogRef: MatDialogRef<DadosDoIntegradorCarteiraIntegradoresModalComponent>,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private clienteService: ClienteService,
    private premissasService: PremissasService,
    private integradorApontamentoService: IntegradorApontamentoService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.idCliente = this.data.idCliente;
    this.buscarCliente();
    this.buscarIntegradorApontamentos();
    this.apontamento = new IntegradorApontamento();
  }

  buscarCliente() {
    this.carregandoService.mostra("buscaCliente");

    this.clienteService.consultarPorIdCliente(this.idCliente, true).subscribe(
      (cli) => {
        this.cliente = cli;

        this.carregandoService.esconde("buscaCliente");
      },
      (erro) => {
        this.carregandoService.esconde("buscaCliente");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarIntegradorApontamentos() {
    this.carregandoService.mostra("buscarIntegradorApontamento");

    this.integradorApontamentoService.consultarComPaginacao(1, 99999999, "dataHora", "desc", this.idCliente).subscribe(
      (data: any) => {
        this.apontamentos = data.itens;

        this.carregandoService.esconde("buscarIntegradorApontamento");
      },
      (erro) => {
        this.carregandoService.esconde("buscarIntegradorApontamento");
        this.notificacaoService.erro(erro);
      }
    );
  }

  adicionarApontamento() {
    this.apontamento.idIntegrador = this.idCliente;

    this.carregandoService.mostra("salvarIntegradorApontamento");
    this.integradorApontamentoService.salvar(this.apontamento).subscribe(
      (retorno) => {
        this.notificacaoService.sucesso("Apontamento adicionado com sucesso!!!");
        this.apontamento.idIntegrador = undefined;
        this.apontamento.texto = undefined;
        this.buscarIntegradorApontamentos();
        this.carregandoService.esconde("salvarIntegradorApontamento");
      },
      (erro) => {
        this.carregandoService.esconde("salvarIntegradorApontamento");
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

  geraTextoSimplesNacional() {
    return this.clienteService.geraTextoSimplesNacional(this.cliente);
  }

  geraTextoSimei() {
    return this.clienteService.geraTextoSimei(this.cliente);
  }

  geraTextoAtualizacaoReceita() {
    return this.clienteService.geraTextoAtualizacaoReceita(this.cliente);
  }
}
